import { render, staticRenderFns } from "./DoYouWantToSwitchFormulaModal.vue?vue&type=template&id=6b061e7b&scoped=true&"
import script from "./DoYouWantToSwitchFormulaModal.vue?vue&type=script&lang=js&"
export * from "./DoYouWantToSwitchFormulaModal.vue?vue&type=script&lang=js&"
import style0 from "./DoYouWantToSwitchFormulaModal.vue?vue&type=style&index=0&id=6b061e7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b061e7b",
  null
  
)

export default component.exports